var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { PeekInputSelect } from "@piiqtechnologies/ui-components";
import React, { useEffect, useMemo } from "react";
export const DEVICE_TYPES = ((_a = process.env.PEEK_APP_ACCESS_DEVICE_TYPES) === null || _a === void 0 ? void 0 : _a.split(";").filter(Boolean)) || [];
const DeviceTypeSelector = (_a) => {
    var { field, form } = _a, props = __rest(_a, ["field", "form"]);
    const selectItems = useMemo(() => DEVICE_TYPES === null || DEVICE_TYPES === void 0 ? void 0 : DEVICE_TYPES.map((type) => ({ id: type, name: type })), []);
    const fieldValue = useMemo(() => {
        switch (field.value.toLowerCase()) {
            case "keybox":
                return "Keybox";
            case "pinpad":
                return "Pinpad";
            case "concierge":
                return "Concierge";
            default:
                return "";
        }
    }, []);
    useEffect(() => {
        // @ts-ignore
        form.setFieldValue(field.name, fieldValue);
    }, [fieldValue]);
    return (React.createElement(PeekInputSelect, Object.assign({ labelProps: { sx: { fontWeight: "normal" } } }, props, { form: form, field: field, items: selectItems })));
};
export default DeviceTypeSelector;
